import { IActionBase, ILogsPageState } from "../models/root.interface";
import { UPDATE_LOADING_STATE_LOG, UPDATE_PAGINATION_TOTAL_LOG, UPDATE_PAGINATION_POSTS_PER_PAGE_LOG, UPDATE_PAGINATION_CURRENT_PAGE_LOG, UPDATE_NOTFOUND_STATE_LOG, UPDATE_TABLE_STATE_LOG, UPDATE_SEARCH_LOG, UPDATE_SEARCH_CURRENT_PAGE_LOG } from "../actions/logsPage.action";



const initialState: ILogsPageState = {
    totalPostsLog: 0, postsPerPageLog: 25, currentPageLog: 1, loadingLog: "block", notFoundLog: "none", tableLog: "none",searchLog:"",currentPageSearchLog:1
};
function logPageReducer(state: ILogsPageState = initialState, action: IActionBase): ILogsPageState {
    switch (action.type) {
        case UPDATE_PAGINATION_TOTAL_LOG:
            return { ...state, totalPostsLog: action.totalPostsLog };
        case UPDATE_PAGINATION_POSTS_PER_PAGE_LOG:
            return { ...state, postsPerPageLog: action.postsPerPageLog };
        case UPDATE_PAGINATION_CURRENT_PAGE_LOG:
            return { ...state, currentPageLog: action.currentPageLog };
        case UPDATE_LOADING_STATE_LOG:
            return { ...state, loadingLog: action.loadingLog };
        case UPDATE_NOTFOUND_STATE_LOG:
            return { ...state, notFoundLog: action.notFoundLog };
        case UPDATE_TABLE_STATE_LOG:
            return { ...state, tableLog: action.tableLog };
        case UPDATE_SEARCH_LOG:
            return { ...state, searchLog: action.searchLog };
        case UPDATE_SEARCH_CURRENT_PAGE_LOG:
            return { ...state, currentPageSearchLog: action.currentPageSearchLog }  
        default:
            return state;
    }
}


export default logPageReducer;